<div class="modal-content">
  <div class="modal-body">
    <div class="headline">{{ 'THE_CUSTOMER_WILL_BE_CHARGED' | translate }}</div>
    <p>{{ 'WHEN_PAYMENT_COMPLETES_HAND_OVER_BAGS' | translate }}</p>
  </div>

  <div class="modal-footer">
    <lh-shared-ui-confirm-button
      id="confirmCheckOut"
      [slideCallToAction]="'SLIDE_TO_CHECK_OUT' | translate"
      [clickCallToAction]="'CHECK_OUT' | translate"
      (confirm)="checkOut()"
      [mode]="'success'"
      [disabled]="!isCheckoutAllowed"
      [isLoading]="isLoading"
    >
    </lh-shared-ui-confirm-button>
  </div>
</div>
